export default __webpack_public_path__ + "static/media/tasks-en.7899874a.png";